import { Button, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { ReactComponent as MicrosoftLogo } from 'images/microsoft.svg';
import { useFeatureFlag } from '@bowery-valuation/feature-flagger-client';
import { featureFlags } from 'utils/config';

type MicrosoftLoginProps = {
  onClick: () => void;
  fullWidth?: boolean;
};

const MicrosoftLogin = ({ onClick, fullWidth }: MicrosoftLoginProps) => {
  const theme = useTheme();
  const xsScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const smScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const microsoftLogin = useFeatureFlag(featureFlags.microsoftLogin);
  if (!microsoftLogin) return null;

  return xsScreen && !fullWidth ? (
    <IconButton aria-label="sign in with Microsoft" onClick={onClick}>
      <MicrosoftLogo />
    </IconButton>
  ) : (
    <Button
      variant="outlined"
      sx={{ lineHeight: '24px', marginRight: '8px', color: 'black', textTransform: 'none', fontWeight: 'normal' }}
      aria-label="sign in with Microsoft"
      onClick={onClick}
      startIcon={<MicrosoftLogo />}
    >
      {smScreen && !fullWidth ? 'Sign In' : 'Sign in with Microsoft'}
    </Button>
  );
};

export { MicrosoftLogin };
